export enum AppwriteMigrationResource {
    User = 'user',
    Team = 'team',
    Membership = 'membership',
    Authmethods = 'auth-methods',
    Policies = 'policies',
    Oauth2provider = 'oauth2-provider',
    Database = 'database',
    Table = 'table',
    Column = 'column',
    Index = 'index',
    Row = 'row',
    Document = 'document',
    Attribute = 'attribute',
    Collection = 'collection',
    Documentsdb = 'documentsdb',
    Vectorsdb = 'vectorsdb',
    Bucket = 'bucket',
    File = 'file',
    Function = 'function',
    Deployment = 'deployment',
    Environmentvariable = 'environment-variable',
    Provider = 'provider',
    Topic = 'topic',
    Subscriber = 'subscriber',
    Message = 'message',
    Site = 'site',
    Sitedeployment = 'site-deployment',
    Sitevariable = 'site-variable',
    Platform = 'platform',
    Apikey = 'api-key',
    Webhook = 'webhook',
    Smtp = 'smtp',
    Backuppolicy = 'backup-policy',
    Projectvariable = 'project-variable',
    Projectprotocols = 'project-protocols',
    Projectlabels = 'project-labels',
    Projectservices = 'project-services',
    Projectemailtemplate = 'project-email-template',
    Projectenvironment = 'project-environment',
    Rule = 'rule',
}
